// extracted by mini-css-extract-plugin
export var share = "share-module--share--2TvGa";
export var title = "share-module--title--2eQKB";
export var socials = "share-module--socials--T2aap";